export type NavLinkItem = {
 link?: string
 subItems?: NavLinkItem[]
 type?: string
}

export function linkMatchesLocation(
 link: string,
 pathname: string,
 search: string,
): boolean {
 const [path, queryPart] = link.split('?')
 const pathMatch = pathname === path || pathname.startsWith(`${path}/`)
 if (!pathMatch) return false
 if (!queryPart) return true

 const wanted = new URLSearchParams(queryPart)
 const current = new URLSearchParams(search)
 let queryOk = true
 wanted.forEach((value, key) => {
 if (current.get(key) !== value) queryOk = false
 })
 return queryOk
}

function linkSpecificityScore(link: string): number {
 const [path, queryPart] = link.split('?')
 let score = path.length * 1000
 if (queryPart) {
 score += new URLSearchParams(queryPart).toString().length
 }
 return score
}

export function collectSidebarLinks(items: NavLinkItem[]): string[] {
 const links: string[] = []

 for (const item of items) {
 if (item.type === 'section') continue
 if (item.link) links.push(item.link)
 if (item.subItems) {
 for (const sub of item.subItems) {
 if (sub.link) links.push(sub.link)
 }
 }
 }

 return Array.from(new Set(links))
}

export function resolveActiveNavLink(
 links: string[],
 pathname: string,
 search: string,
): string | null {
 const matches = links.filter((link) => linkMatchesLocation(link, pathname, search))
 if (matches.length === 0) return null

 return matches.reduce((best, current) =>
 linkSpecificityScore(current) > linkSpecificityScore(best) ? current : best,
 )
}

export function isNavLinkActive(
 link: string,
 pathname: string,
 search: string,
 allLinks: string[],
): boolean {
 return resolveActiveNavLink(allLinks, pathname, search) === link
}
